import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { ShiNote } from "@/components/ShiNote";
import { IMAGES } from "@/lib/images";
import Seo from "@/components/Seo";
import { SHI_SHEET_URL } from "@/lib/images";

export default function ShiSipsPage() {
  return (
    <div data-testid="shi-sips-page" className="pt-32 pb-28 md:pt-40">
      <Seo title="Shi Sips | That’s What SHi Said" description="A cocktail on camera with every episode of The Program, and its matching mocktail recipe here." path="/shi-sips" />
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <Overline>The Ritual</Overline>
            <h1 className="relative mt-4 font-display text-5xl font-black leading-[0.9] tracking-tight md:text-7xl">
              Shi Sips
              <ShiNote className="ml-3 align-middle text-2xl md:text-3xl" rotate="-rotate-3">
                pour something.
              </ShiNote>
            </h1>
            <p className="mt-8 max-w-xl font-editorial text-2xl italic leading-relaxed text-gold/90 md:text-3xl">
              A drink for the conversation. Make yours how you like it.
            </p>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-latte md:text-lg">
              Every episode of The Program, SHi makes one cocktail on camera. The matching mocktail recipe lands here.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="overflow-hidden rounded-[2rem] border border-corduroy">
              <img
                src={IMAGES.drink}
                alt="The Shi Sips bar cart"
                data-testid="shi-sips-image"
                className="aspect-[4/5] w-full object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>

        <Reveal className="mt-24">
          <motion.div
            data-testid="shi-sips-coming-soon"
            className="rounded-3xl border border-ember/30 bg-cocoa p-10 md:p-16"
          >
            <p className="font-editorial italic text-3xl text-ember md:text-4xl">
              First pour: Program 001, Thursday, December 3, 2026.
            </p>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-latte md:text-lg">
              No recipes yet. The first mocktail lands with Program 001.
            </p>
            <a
              href={SHI_SHEET_URL}
              target="_blank"
              rel="noopener"
              data-testid="shi-sips-notify-button"
              className="mt-8 inline-block rounded-full bg-ember px-8 py-4 font-bold text-ink transition-colors hover:bg-neon hover:text-cream"
            >
              Get The Shi Sheet
            </a>
          </motion.div>
        </Reveal>
      </div>
    </div>
  );
}
